/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import React from 'react';
import { observer } from 'mobx-react';
import { Route, withRouter } from 'react-router';


export default withRouter(observer(({
    appLoader, appConfig, appsPanelSkeleton, apps, banners, match,
}) => {
    const { sectionGroupList } = appsPanelSkeleton;
    return sectionGroupList.map(({ appSections }) => (
        appSections.map(appSection => (
            <Route
                key={appSection.id}
                path={`${match.path}/${appSection.id}`}
                render={(props) => {
                    const { layouts } = appConfig;
                    const { layoutID } = appSection;
                    const AppsCatalogLayout = (
                        layoutID && Object.prototype.hasOwnProperty.call(
                            layouts.appsCatalog, layoutID
                        )
                    ) ? layouts.appsCatalog[layoutID] : layouts.appsCatalog.appsCatalogDefault;
                    return (
                        <AppsCatalogLayout
                            appLoader={appLoader}
                            appsSkeletonModel={appsPanelSkeleton}
                            allAppsModel={apps}
                            bannersModel={banners}
                            appSection={appSection}
                            appConfig={appConfig}
                            {...props}
                        />
                    );
                }} />
        ))
    ));
}));
